import React from "react";
import useStreamStatus from "../../../../hooks/site/useStreamStatus.js";
import ShowContainer from "../../../mui/ShowContainer.jsx";
import UnavailableModal from "./UnavailableModal.jsx";
import "./unavailable-modal.scss";

export default function UnavailableControl() {
  const { isStream } = useStreamStatus();

  return (
    <ShowContainer condition={!isStream}>
      <UnavailableModal />
    </ShowContainer>
  );
}
